<template>
    <div class="layout-record-top-bar dsp-flex">
        <!-- @click="clickGroup" -->
        <div class="layout-rtb-side" @click.passive="clickGroup">分组<br>管理</div>
        <div class="layout-rtb-mid" @click.passive="clickSearch">
            <div class="com-search-input">
                <i class="iconfont icon-search com-i-s"></i>
                <input class="com-si-input" type="text" placeholder="搜索" :disabled='true' >
            </div>
        </div>
        <div class="layout-rtb-side" @click.passive="clickCollate">八字<br>起盘</div>
    </div>
</template>

<script>
export default {
    name: 'RecordTopBar',
    computed: {
    },
    methods:{
        clickSearch() {
            this.$store.dispatch('search/resetData');
            this.$router.replace('/search');
        },
        clickGroup() {
            this.$router.replace('/record/groupmanage');
        },
        clickCollate() {
            this.$router.replace('/collate')
        }
    }
}
</script>